<template>
  <div id="search-wrapper" :class="{ mobile: isSmallScreen}" class="search-wrapper">
    <input
        v-model="query"
        v-on:keyup.enter="onInput"
        v-on:input="onInput"
        placeholder="Zoek in een klantbestand..."
        class="search"
        type="text"
        autocomplete="off"
        spellcheck="false"
        data-lpignore="true"
    />
    <span :style="{cursor: 'pointer' }" @click="onInput" class="search-button">
          <MagnifyIcon title="" class="icon-size-lg"></MagnifyIcon>
    </span>
  </div>

</template>

<script>
import scoutSearchApi from '~/api/scout_search';

export default {
  name: "SearchBarComponent.vue",
  emits: ['openModal', 'isLoading', 'results'],
  props: {
    isSmallScreen: Boolean,
  },
  data() {
    let models = [
          'customer',
          'mortgage',
          'policy',
          'damage',
          'credit',
        ];
    return {
      query: '',
      timer: null,
      models: models,
      include: [...models, 'customer.current_visit_customer_property.property'],
    }
  },
  methods: {
    submitSearch() {
      if(this.query.length === 0 ) return;
      scoutSearchApi.search(this.query, this.models, this.include).then((response) => {
        this.$emit('results', response.data)
        this.$emit('isLoading', false);
      });
    },
    onInput() {
      if (this.query.length === 0) return;
      this.$emit('openModal');
      this.startDebounce();
    },
    startDebounce() {
      this.$emit('isLoading', true);
      this.debounce(() => this.submitSearch())();
    },
    debounce(func, timeout = 200) {
      return (...args) => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          func.apply(this, args);
        }, timeout);
      };
    },
  }
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "~@/_default.scss";

.mobile-search {
  @media (min-width: 992px) {
    display: none;
  }
  display: inherit;
}

.search-wrapper {
  position: relative;
  width: ($navbar-search-width - 100px);
  height: 30px;
  padding-left: $spacing-sm;
  padding-right: calc($spacing-sm  + $spacing-lg);
  background-color: $blue-light;
  border-radius: $border-radius-base;
  display: flex;
  place-content: center;

  &.mobile {
    height: $navbar-search-height;
    background-color: $main-content-bg-color;
    border: 1px solid $brand-primary;
    padding-left: $spacing-md;
    padding-right: calc(#{$spacing-md}  + #{$spacing-lg});
    width: 100%;

    span.search-button {
      color: $text-color
    }

    input.search {
      font-size: $font-size-base;
      color: $text-color;
    }
  }

  input.search {
    color: white;
    font-size: $font-size-base;

    background-color: transparent;
    width: 100%;
    border: none;
    outline: none;
  }
}

.search-wrapper {
  .search::placeholder {
    color: $main-content-bg-color;
    opacity: 0.8
  }

  &.mobile {
    .search::placeholder {
      color: $text-color;
      opacity: 0.3
    }
  }


}

span.search-button {
  position: absolute;
  top: 0;
  bottom: 0;
  right: $spacing-md;
  color: white;
  border: none;
  margin-top: auto;
  margin-bottom: auto;
  background: transparent;
  display: flex;
  align-items: center;
}

.search-mobile-wrapper {
  display: none;
  height: 30px;
  position: relative;
}

@media (max-width: map.get($grid-breakpoints, lg)) {

  .search-mobile-wrapper {
    display: flex;
  }

}

@media(min-width: map.get($grid-breakpoints, xxl)) {
  .mobile-search {
    display: none;
  }
}

</style>
